



































































































































































































































































import {Component, Prop} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import {SaveStageSummary} from "@/api/hd"
import {GetDoctor} from "@/api/dialysisProcess"

@Component
export default class DialysisSummary extends AbpBase {
	@Prop({type: Boolean, default: false}) value: boolean
	@Prop() data: any
	doctors:any = []
	model:any = {
		inputDate: new Date()
	}
	created(){
		this.getSelects()
		if (this.data.mode === 'edit') {
			this.model = Object.assign({}, this.data.data)
		}
	}
	save(){
		(this.$refs.form as any).validate(async (valid:boolean)=> {
			if (valid) {
				this.model.patientId = this.data.patient.id
				this.model.inputDate = this.formatDate(this.model.inputDate)
				let res = await SaveStageSummary(this.model)
				if (res.status === 1) {
					this.$emit('save-success')
				}
			}
		})
	}
	rules = {
		inputDate:[{required: true,message:this.L('FieldIsRequired')}],
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}
	cancel() {
		this.$emit('input', false);
	}
	get modalTitle() {
		return this.data.mode === 'add' ? '新增' : '编辑'
	}
	async getSelects() {
		let res = await GetDoctor()
		this.doctors = res.objects
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/treatmentAnalysis/addOrEditDialysisSummary.vue